
import React from "react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { useLead } from "./useLeads";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface LeadDetailModalProps {
  leadId: string | null;
  isOpen: boolean;
  onClose: () => void;
}

const LeadDetailModal: React.FC<LeadDetailModalProps> = ({
  leadId,
  isOpen,
  onClose
}) => {
  const { lead, isLoading, error } = useLead(leadId);

  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onOpenChange={() => onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Detalhes do Lead</DialogTitle>
        </DialogHeader>
        
        {isLoading ? (
          <div className="flex justify-center p-6">
            <Loader2 className="h-8 w-8 text-[#FF5605] animate-spin" />
          </div>
        ) : error ? (
          <div className="p-6 text-red-500">
            Erro ao carregar detalhes: {error}
          </div>
        ) : lead ? (
          <div className="space-y-4 py-4">
            <div className="grid grid-cols-[100px_1fr] gap-2">
              <span className="font-medium text-gray-700">Nome:</span>
              <span>{lead.name}</span>
              
              <span className="font-medium text-gray-700">E-mail:</span>
              <span>{lead.email}</span>
              
              <span className="font-medium text-gray-700">Telefone:</span>
              <span>{lead.phone}</span>
              
              <span className="font-medium text-gray-700">Origem:</span>
              <span>{lead.page || "Não informado"}</span>
              
              <span className="font-medium text-gray-700">Cadastrado em:</span>
              <span>
                {format(
                  new Date(lead.created_at),
                  "dd/MM/yyyy 'às' HH:mm",
                  { locale: ptBR }
                )}
              </span>
            </div>
          </div>
        ) : (
          <div className="p-6 text-gray-500">
            Lead não encontrado
          </div>
        )}
        
        <DialogFooter>
          <Button 
            onClick={onClose}
            variant="secondary"
          >
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LeadDetailModal;
